/* ============================================
   catch it - Internationalization (EN/DE)
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {

  const STORAGE_KEY = 'catchit-lang';
  const SUPPORTED_LANGS = ['en', 'de'];
  const DEFAULT_LANG = 'en';

  // Resolve initial language: localStorage > html[lang] > default
  function getInitialLang() {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && SUPPORTED_LANGS.includes(stored)) return stored;
    const htmlLang = document.documentElement.lang;
    if (htmlLang && SUPPORTED_LANGS.includes(htmlLang)) return htmlLang;
    return DEFAULT_LANG;
  }

  let currentLang = getInitialLang();

  /**
   * Apply the current language to all translatable elements.
   * Uses innerHTML so that attribute values containing HTML (e.g. <a> links) render correctly.
   */
  function applyLanguage(lang) {
    currentLang = lang;
    localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;

    // Update all elements carrying data-en / data-de
    document.querySelectorAll('[data-en][data-de]').forEach(el => {
      const translated = el.getAttribute(`data-${lang}`);
      if (translated !== null) {
        el.innerHTML = translated;
      }
    });

    // Update toggle button label (shows the OTHER language as the action)
    const langToggle = document.getElementById('langToggle');
    if (langToggle) {
      langToggle.textContent = lang === 'en' ? 'DE' : 'EN';
    }

    // Dispatch a custom event so other scripts can react
    window.dispatchEvent(new CustomEvent('catchit:langchange', {
      detail: { lang }
    }));
  }

  // Apply language immediately on page load
  applyLanguage(currentLang);

  // Toggle button click handler
  const langToggle = document.getElementById('langToggle');
  if (langToggle) {
    langToggle.addEventListener('click', () => {
      const nextLang = currentLang === 'en' ? 'de' : 'en';
      applyLanguage(nextLang);
    });
  }

  // Expose utility on window for other scripts
  window.catchitI18n = {
    /** Get the current language code */
    getLang() { return currentLang; },
    /** Programmatically switch language */
    setLang(lang) {
      if (SUPPORTED_LANGS.includes(lang) && lang !== currentLang) {
        applyLanguage(lang);
      }
    },
  };

});
